module.exports = __webpack_public_path__ + "ba5808104a2d7de14ca000b1856ab9fc.pdf";